
import React, { useState } from 'react';
import { ExperimentVariants } from 'utils/types';
import Button from 'components/control/button';
import Listing from 'data/listing';
import styles from './style.module.scss';
import HomeAppraisalConnectionRequest from 'components/home-appraisal-connection-request';
import { buildClassName } from 'utils/build-class-name';
import { useTranslation } from 'next-i18next';
import { LOCALE_COMMON_PATHS, Namespaces } from 'types/locales';
import { useRouter } from 'next/router';
import { AnalyticsController } from 'analytics/analytics-controller';
import { GTM_CLICK_ADDRESS_PAGE_OFFLINE_ESTIMATE_BUT_CLICK, GTM_CLICK_ADDRESS_PAGE_ONLINE_ESTIMATE_BUT_CLICK } from 'constants/events';


type SoldListingExperimentCardProps = {
  mode: ExperimentVariants.A | ExperimentVariants.B;
  listing: Listing;
};

export default function SoldListingExperimentCard({ mode, listing }: SoldListingExperimentCardProps) {
  const { t } = useTranslation(Namespaces.COMMON);
  const router = useRouter();
  const [showPVRForm, setShowPVRForm] = useState(false);

  const handleOnGetEstimateClick = () => {
    if (mode === ExperimentVariants.A) {
      AnalyticsController.trackEvent(GTM_CLICK_ADDRESS_PAGE_ONLINE_ESTIMATE_BUT_CLICK);
      setShowPVRForm(true);
    } else {
      AnalyticsController.trackEvent(GTM_CLICK_ADDRESS_PAGE_OFFLINE_ESTIMATE_BUT_CLICK);
      router.push('/home-appraisal');
    }
  };

  return (
    <div className={buildClassName(styles.component, showPVRForm && styles['no-padding'])}>
      {showPVRForm ?
        <HomeAppraisalConnectionRequest listing={listing} />
        :
        <div className={styles.container}>
          <div
            className={styles.imageContainer}
            role="img"
            aria-label={
              t(LOCALE_COMMON_PATHS.ADDRESS_SOLD_LISTING_EXPERIMENT_CARD_ALT_TEXT,
                { defaultValue: 'For Sale' }
              )
            }
          />
          <div className={styles.description}>
            <h3>
              {t(LOCALE_COMMON_PATHS.ADDRESS_SOLD_LISTING_EXPERIMENT_CARD_TITLE,
                {
                  context: mode === ExperimentVariants.A ? 'a' : 'b',
                  defaultValue: 'How much is your home worth?',
                })
              }
            </h3>
          </div>
          <Button
            theme='primary'
            label={
              t(LOCALE_COMMON_PATHS.ADDRESS_SOLD_LISTING_EXPERIMENT_CARD_BUTTON_LABEL,
                {
                  context: mode === ExperimentVariants.A ? 'a' : 'b',
                  defaultValue: 'Get a Free Online Estimate',
                })
            }
            onClick={handleOnGetEstimateClick}
          />
        </div>
      }
    </div>
  );
}